import demandService from '@/service/demand';
import HRService from '@/service/hr';
import Cookies from 'js-cookie';
import localforage from 'localforage';
import { observable, action, runInAction } from 'mobx';


// 获取人均福利分布

const moCompany = observable({
  companyType: 'chart',
  companyActive: 'industry',
  companyRankType: 'chart',
  companyRankActive: 'num',
  activeTime: 2022,
  activeTime1: "年度",
  activeRankTime: 2022,
  timeList: <any>[],
  timeRankList: <any>[],
  companyIndsutryList: <any>[],
  companyIndsutryListTime: <any>[],
  companyRankList: <any>[],
  city: '全国',
  companyModel: false,
});

// 切换公司招聘动向表格图表

const emen: any = {
  "年度": "year",
  "季度": "quarter",
  "月度": "month",
}

const changeCompanyType = action(async (val: string) => {
  runInAction(() => {
    moCompany.companyType = val;
  })
  const local: any = await localforage.getItem('demand') || {};
  local['companyType'] = val;
  localforage.setItem('demand', local)
})

// 切换公司招聘动向tab

const changeCompanyActive = action(async (val: string) => {
  runInAction(() => {
    moCompany.companyActive = val;
  })
  const local: any = await localforage.getItem('demand') || {};
  local['companyActive'] = val;
  localforage.setItem('demand', local)
})

// 切换典型公司招聘量涨幅排行图表

const changeCompanyRankType = action(async (val: string) => {
  runInAction(() => {
    moCompany.companyRankType = val;
  })
  const local: any = await localforage.getItem('demand') || {};
  local['companyRankType'] = val;
  localforage.setItem('demand', local)
})

// 切换典型公司招聘量涨幅排行tab

const changeCompanyRankActive = action(async (val: string) => {
  runInAction(() => {
    moCompany.companyRankActive = val;
  })
  const local: any = await localforage.getItem('demand') || {};
  local['companyRankActive'] = val;
  localforage.setItem('demand', local)
})

// 修改时间

const changeActiveTime = action(async (val: any) => {
  runInAction(() => {
    moCompany.activeTime = val;
  })
  const companyIndsutryList = await demandService.getCompanyIndustry({ date: val })
  runInAction(() => {
    moCompany.companyIndsutryList = companyIndsutryList;
  })
  const local: any = await localforage.getItem('demand') || {};
  local['companyActiveTime'] = val;
  localforage.setItem('demand', local)
})

const changeInitTime1 = action((val: string) => {
  runInAction(() => {
    moCompany.activeTime1 = val;
  })
})

const changeActiveTime1 = action(async (val: any) => {
  runInAction(() => {
    moCompany.activeTime1 = val;
  })

  const companyIndsutryList = await demandService.getCompanyIndustryTime({ time_type: emen[val] })
  runInAction(() => {
    moCompany.companyIndsutryListTime = companyIndsutryList;
  })
  const local: any = await localforage.getItem('demand') || {};
  local['companyActiveTime1'] = val;
  localforage.setItem('demand', local)
})

// 各行业公司招聘动向时间

const getTimeList = action(async () => {
  const local: any = await localforage.getItem('demand') || {};
  const timeList = await demandService.getCompanyTime()
  runInAction(() => {
    moCompany.timeList = timeList;
    moCompany.activeTime = local['companyActiveTime'] ? local['companyActiveTime'] : timeList[timeList.length - 1];
  })
})

// 典型公司招聘量涨幅排行改变时间

const changeRankActiveTime = action(async (val: any) => {
  runInAction(() => {
    moCompany.activeRankTime = val;
  })
  const companyRankList = await demandService.getCompanyRankList({ date: val })
  runInAction(() => {
    moCompany.companyRankList = companyRankList;
  })
  const local: any = await localforage.getItem('demand') || {};
  local['companyActiveRankTime'] = val;
  localforage.setItem('demand', local)
})

// 涨幅排行时间

const getCompanyRankTime = action(async () => {
  const local: any = await localforage.getItem('demand') || {};
  const timeList = await demandService.getCompanyRankTime()
  runInAction(() => {
    moCompany.timeRankList = timeList;
    moCompany.activeRankTime = local['companyActiveRankTime'] ? local['companyActiveRankTime'] : timeList[timeList?.length - 1];
  })
})

// 涨幅排行列表


const getCompanyRankList = action(async () => {
  const companyRankList = await demandService.getCompanyRankList({ date: moCompany.activeRankTime })
  runInAction(() => {
    moCompany.companyRankList = companyRankList;
  })
})

// 各行业招聘动向

const getConapanyIndustry = action(async () => {
  const companyIndsutryList = await demandService.getCompanyIndustry({ date: moCompany.activeTime })
  runInAction(() => {
    moCompany.companyIndsutryList = companyIndsutryList;
  })
})

const getCompanyIndustryTime = action(async () => {
  const companyIndsutryList = await demandService.getCompanyIndustryTime({ time_type: emen[moCompany.activeTime1] })
  runInAction(() => {
    moCompany.companyIndsutryListTime = companyIndsutryList;
  })
})

// 关闭弹窗

const closeModel = action(() => {
  runInAction(() => {
    moCompany.companyModel = false;
  })
})

// 确认关闭弹窗

const onOkModel = action(async(val: string) => {
  runInAction(() => {
    moCompany.companyModel = false;
    moCompany.city = val;
  })
  const parmes = {
    access_token: Cookies.get('access_token'),
    top_company_city: val,
  }
  await HRService.editUserOption(parmes);
  getCompanyRankList();
})

const changeDefaltCity = action((val: string) => {
  runInAction(() => {
    moCompany.city = val;
  });
})

// 打开弹窗

const openModel = action(() => {
  runInAction(() => {
    moCompany.companyModel = true;
  })
})


export default moCompany;
export {
  changeCompanyType, changeCompanyActive, changeCompanyRankType, changeCompanyRankActive, changeActiveTime,
  getTimeList, getConapanyIndustry, changeActiveTime1, getCompanyIndustryTime, changeRankActiveTime,
  getCompanyRankTime, getCompanyRankList, changeInitTime1, closeModel, onOkModel, openModel, changeDefaltCity,
};
